import React from 'react';
import { Helmet } from 'react-helmet';
import { withToastManager } from 'react-toast-notifications';
import xhr from 'xhr.js';
import auth from 'services/auth';
import ReactTooltip from 'react-tooltip';
import TooltipIcon from 'components/TooltipIcon';
import ReactModal from 'react-modal';
import InputError from 'components/InputError';
import helpers from 'utils/helpers';
import { CURRENCIES, CURRENCY_SYMBOL } from 'utils/constants';

import { FiEdit, FiImage, FiCopy, FiCheckCircle, FiTrash, FiCamera, FiTrash2, FiXCircle } from 'react-icons/fi';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box, Button, Heading } from 'rebass';
import { Label, Input, Textarea, Switch, Select } from '@rebass/forms';
import services from 'services/services';
import service_accounts from 'services/accounts';
import TextAreaAutosize from 'react-textarea-autosize';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import SettingsPageSubNav from 'containers/SettingsPage/SettingsPageSubNav';

import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';

import NiceModal from 'components/NiceModal';

class SettingsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            account: this.props.auth.account,
            uploadingAccountLogo: false,
            uploadingScreenBg: false,
            uploadingFavicon: false,
            showModalCreateDomain: false,
            onCreateDomain_loading: false,
            showModalVerifyDomain: false,
            onVerifyDomain_loading: false,
            domain_selected: {},
            sender_profile_selected: {},
            showModalSenderProfile: false,
            sender_profiles: [],
            sender_profiles_loading: true
        };

        this.onFormChange = this.onFormChange.bind(this);
        this.accountLogoUploadButton = this.accountLogoUploadButton.bind(this);
        this.accountLogoRemoveButton = this.accountLogoRemoveButton.bind(this);
        this.screenerBgUploadButton = this.screenerBgUploadButton.bind(this);
        this.screenerBgRemoveButton = this.screenerBgRemoveButton.bind(this);
        this.faviconUploadButton = this.faviconUploadButton.bind(this);
        this.faviconRemoveButton = this.faviconRemoveButton.bind(this);

        this.handleCloseModalSenderProfile = this.handleCloseModalSenderProfile.bind(this);
        this.onCreateSenderProfile = this.onCreateSenderProfile.bind(this);
        this.onSubmitFormSenderProfile = this.onSubmitFormSenderProfile.bind(this);

        this.handleCloseModalCreateDomain = this.handleCloseModalCreateDomain.bind(this);
        this.onCreateDomain = this.onCreateDomain.bind(this);

        this.handleCloseModalVerifyDomain = this.handleCloseModalVerifyDomain.bind(this);
        this.onVerifyDomain = this.onVerifyDomain.bind(this);

        this.dkimKeyStripDomain = this.dkimKeyStripDomain.bind(this);
        this.returnpathKeyStripDomain = this.returnpathKeyStripDomain.bind(this);
    }

    componentDidMount() {
        this.getSenderProfilesXHR();

        // for testing
        /*xhr.get(`/http-response/504`, {
            withCredentials: true
        });*/
    }

    handleCloseModalVerifyDomain() {
        this.setState({ showModalVerifyDomain: false });
    }

    onVerifyDomain(e) {
        e.preventDefault();
        const { toastManager } = this.props;

        this.setState({ onVerifyDomain_loading: true });

        service_accounts
            .verifyDomain(this.state.domain_selected.id)
            .then(domainVerified => {
                this.setState({
                    onVerifyDomain_loading: false,
                    showModalCreateDomain: false
                });

                toastManager.add('Successfully verified domain', {
                    appearance: 'success',
                    autoDismiss: true
                });

                location.reload();
            })
            .catch(error => {
                this.setState({ onVerifyDomain_loading: false });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onDeleteDomain(id) {
        if (!confirm('Are you sure? This will delete all related sender profiles.')) {
            return;
        }

        const { toastManager } = this.props;

        service_accounts
            .deleteDomain(id)
            .then(() => {
                toastManager.add('Successfully deleted', {
                    appearance: 'success',
                    autoDismiss: true
                });
                let { account } = this.state;
                const found = account.domains.find(d => d.id == id);
                if (found) {
                    const index = account.domains.indexOf(found);
                    account.domains.splice(index, 1);
                }
                this.setState({ account });
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onDeleteSenderProfile(id) {
        if (!confirm('Are you sure?')) {
            return;
        }

        const { toastManager } = this.props;

        service_accounts
            .deleteSenderProfile(id)
            .then(() => {
                toastManager.add('Successfully deleted', {
                    appearance: 'success',
                    autoDismiss: true
                });
                location.reload();
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    handleCloseModalCreateDomain() {
        this.setState({ showModalCreateDomain: false });
    }

    onCreateDomain(e) {
        e.preventDefault();
        const { toastManager } = this.props;

        const domain = document.getElementsByName('create_domain_url');

        this.setState({ onCreateDomain_loading: true });

        service_accounts
            .createDomain(domain[0].value)
            .then(domain => {

                let { account } = this.state;
                account.domains.push(domain);
                this.setState({ account });

                this.setState({
                    domain_selected: domain,
                    showModalCreateDomain: false,
                    onCreateDomain_loading: false,
                    showModalVerifyDomain: true
                });

                toastManager.add('Successfully created domain', {
                    appearance: 'success',
                    autoDismiss: true
                });
            })
            .catch(error => {
                this.setState({ onCreateDomain_loading: false });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    handleCloseModalSenderProfile() {
        this.setState({ showModalSenderProfile: false });
    }

    onSubmitFormSenderProfile(e) {
        e.preventDefault();
        if (this.state.sender_profile_selected.id) {
            this.onUpdateSenderProfile();
        } else {
            this.onCreateSenderProfile();
        }
    }

    onUpdateSenderProfile() {
        
        const { toastManager } = this.props;

        this.setState({ onCreateSenderProfile_loading: true });

        service_accounts
            .updateSenderProfile(this.state.sender_profile_selected.id, this.state.sender_profile_selected.email, this.state.sender_profile_selected.name)
            .then(senderProfile => {
                this.setState({ onCreateSenderProfile_loading: false });
                this.handleCloseModalSenderProfile();

                toastManager.add('Updated sender profile', {
                    appearance: 'success',
                    autoDismiss: true
                });

                let { sender_profiles } = this.state;
                const found = sender_profiles.find(sp => sp.id == senderProfile.id);
                const index = sender_profiles.indexOf(found);
                sender_profiles[index] = senderProfile;
                this.setState({sender_profiles});                
            })
            .catch(error => {
                this.setState({ onCreateSenderProfile_loading: false });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }


    onCreateSenderProfile() {
        
        const { toastManager } = this.props;

        this.setState({ onCreateSenderProfile_loading: true });

        service_accounts
            .createSenderProfile(this.state.sender_profile_selected.email, this.state.sender_profile_selected.name)
            .then(senderProfile => {
                this.setState({ onCreateSenderProfile_loading: false });

                toastManager.add('Created sender profile', {
                    appearance: 'success',
                    autoDismiss: true
                });

                let { sender_profiles } = this.state;
                sender_profiles.push(senderProfile);
                this.setState({sender_profiles});

                this.handleCloseModalSenderProfile();
            })
            .catch(error => {
                this.setState({ onCreateSenderProfile_loading: false });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    isColor(strColor) {
        const s = new Option().style;
        s.color = strColor;
        return s.color !== '';
    }

    accountLogoRemoveButton() {
        const { toastManager } = this.props;

        xhr.delete(`/accounts/${this.props.auth.account.id}/logo`, {
            withCredentials: true
        }).then(account_xhr => {
            auth.checkAuth();
            const { account } = this.state;
            account.logo = account_xhr.logo;
            this.setState({
                account
            });
        }).catch(error => {

            const errorText = services.parseXhrErrors(error);

            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        });
    }

    accountLogoUploadButton() {
        const { toastManager } = this.props;
        document.getElementById('organization_logo').click();
        document.getElementById('organization_logo').onchange = e => {

            this.setState({ uploadingAccountLogo: true });

            const formData = new FormData();
            formData.append('logo', e.target.files[0]);

            console.log(this.props.auth.account.id);

            xhr.post(`/accounts/${this.props.auth.account.id}/logo`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(account_xhr => {
                auth.checkAuth();
                const { account } = this.state;
                account.logo = account_xhr.data.logo;
                this.setState({
                    uploadingAccountLogo: false,
                    account
                });
            }).catch(error => {

                this.setState({
                    uploadingAccountLogo: false
                });

                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
        };
    }

    screenerBgRemoveButton() {
        const { toastManager } = this.props;

        xhr.delete(`/accounts/${this.props.auth.account.id}/screener-bg`, {
            withCredentials: true
        }).then(account_xhr => {
            auth.checkAuth();
            const { account } = this.state;
            account.screener_bg = account_xhr.screener_bg;
            this.setState({
                account
            });
        }).catch(error => {

            const errorText = services.parseXhrErrors(error);

            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        });
    }

    screenerBgUploadButton() {
        const { toastManager } = this.props;
        document.getElementById('organization_screener_bg').click();
        document.getElementById('organization_screener_bg').onchange = e => {

            this.setState({ uploadingScreenBg: true });

            const formData = new FormData();
            formData.append('screener_bg', e.target.files[0]);

            console.log(this.props.auth.account.id);

            xhr.post(`/accounts/${this.props.auth.account.id}/screener-bg`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(account_xhr => {
                auth.checkAuth();
                const { account } = this.state;
                account.screener_bg = account_xhr.data.screener_bg;
                this.setState({
                    uploadingScreenBg: false,
                    account
                });
            }).catch(error => {

                this.setState({
                    uploadingScreenBg: false
                });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
        };
    }

    faviconRemoveButton() {

        const { toastManager } = this.props;

        xhr.delete(`/accounts/${this.props.auth.account.id}/favicon`, {
            withCredentials: true
        }).then(account_xhr => {
            auth.checkAuth();
            const { account } = this.state;
            account.favicon = account_xhr.favicon;
            this.setState({
                account
            });
        }).catch(error => {

            const errorText = services.parseXhrErrors(error);

            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        });
    }

    faviconUploadButton() {

        const { toastManager } = this.props;
        document.getElementById('organization_favicon').click();
        document.getElementById('organization_favicon').onchange = e => {

            this.setState({ uploadingFavicon: true });

            const formData = new FormData();
            formData.append('favicon', e.target.files[0]);

            //console.log(this.props.auth.account.id);

            xhr.post(`/accounts/${this.props.auth.account.id}/favicon`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(account_xhr => {
                auth.checkAuth();
                const { account } = this.state;
                account.favicon = account_xhr.data.favicon;
                this.setState({
                    uploadingFavicon: false,
                    account
                });
            }).catch(error => {

                this.setState({
                    uploadingFavicon: false
                });
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
        };
    }

    onFormChange(e) {
        if (!e.target.name) {
            e.preventDefault();
            return;
        }
        const account = { ...this.state.account };
        //console.log('clicked')
        const key = e.target.name;
        const val = e.target.value;
        if (key.includes('branding.') !== false) {
            const subkey = key.substring(9);
            e.target.setCustomValidity('');
            account.branding[subkey] = val;
        } else if (key == 'allow_session_changes') {
            account['allow_session_changes'] = !account['allow_session_changes'];
        } else {
            account[key] = val;
        }

        this.setState({ account });

        // detect change, and clear timeout if exists
        if (this.saveDelay) {
            clearTimeout(this.saveDelay);
        }

        // set timer for 200ms
        this.saveDelay = setTimeout(
            function() {
                this.saveAccountXHR(account);
            }.bind(this),
            300
        );
    }

    saveAccountXHR(account) {
        //console.log('SAVED!!!', account);

        const { toastManager } = this.props;

        xhr.put(`/accounts/${account.id}`, account, { withCredentials: true })
            .then(() => {
                toastManager.add('Saved', {
                    appearance: 'success',
                    autoDismiss: true
                });

                auth.checkAuth();
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: false
                });
            });
    }

    dkimKeyStripDomain() {
        return this.state.domain_selected.dkimhost.replace('.'+this.state.domain_selected.domain, '');
    }

    returnpathKeyStripDomain() {
        return this.state.domain_selected.returnpathhost.replace('.'+this.state.domain_selected.domain, '');
    }

    showSenderProfiles() {
        let showSS = false;
        this.state.account.domains.forEach(d => {
            if (d.dkim_verified && d.returnpath_verified) {
                showSS = true;
            }
        })

        return showSS;
    }

    getSenderProfilesXHR() {
        const { toastManager } = this.props;
        
        service_accounts
            .getSenderProfiles()
            .then(sender_profiles => {
                this.setState({sender_profiles, sender_profiles_loading: false})
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);
                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
                this.setState({sender_profiles_loading: false})
            });
    }

    isDomainVerified(account_domain) {
        let isVerified = false;
        if (account_domain.dkim_verified && account_domain.returnpath_verified) {
            isVerified = true;
        }
        return isVerified;
    }

    render() {

        return (
            <Flex style={{ width: '100%' }}>
                <AppPageWrapper>
                    <Helmet>
                        <title>Organization Settings</title>
                    </Helmet>

                    <AppPageSubnav>
                        <SettingsPageSubNav/>
                    </AppPageSubnav>

                    <AppPageWrapperSectionHeader className='experience'>
                        <Box>
                            <H1>General</H1>
                            <Box className='experience-description'>
                                General organization settings.
                            </Box>
                        </Box>
                    </AppPageWrapperSectionHeader>
                    <AppPageWrapperSectionBody>
                        <form onSubmit={this.onFormChange}>
                            <Flex mx={4} my={3} className='form-wrapper'>
                                <Box width={1/4} mb={4}>
                                    <H2>Organization</H2>
                                </Box>
                                <Box width={3/4} mb={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                    <Box width={1/3} className='form-label'>
                                        Display Name
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <Input
                                            type="text"
                                            name="title"
                                            placeholder="Title"
                                            value={this.state.account.title}
                                            onChange={this.onFormChange}
                                        />
                                    </Box>
                                    <Box width={1/3} className='form-label'>
                                        Default Currency
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <Select
                                            style={{maxWidth: '120px'}}
                                            name="incentive_currency"
                                            value={this.state.account.incentive_currency}
                                            onChange={this.onFormChange}>
                                            {CURRENCIES.map(c => {
                                                return <option value={c}>{CURRENCY_SYMBOL[c]} ({c})</option>
                                            })}
                                        </Select>
                                    </Box>
                                </Box>
                                <Box width={1/4}>
                                    <H2>Branding</H2>
                                    <Label className='quiet'>
                                        The logo will be used as the header in emails and screeners.
                                        Primary and secondary colors will be used for buttons and links.
                                    </Label>
                                </Box>
                                <Box width={3/4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                    <Box width={1/3} className='form-label'>
                                        Logo
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        {this.state.account.logo ? (
                                            <Box mb={2}>
                                                <img
                                                    src={this.state.account.logo}
                                                    style={{ width: '48px', borderRadius: '4px', overflow: 'hidden' }}
                                                    alt="Organization Logo"
                                                />
                                            </Box>
                                        ) : (
                                            <></>
                                        )}

                                        <Button
                                            type="button"
                                            variant="link"
                                            onClick={this.accountLogoUploadButton}
                                            disabled={this.state.uploadingAccountLogo}
                                            mr={3}
                                        >
                                            {this.state.uploadingAccountLogo ? 'Uploading...' : <><FiCamera/> Upload image</>}
                                        </Button>
                                        <input type="file" id="organization_logo" accept=".png, .jpg, .jpeg" hidden />
                                        {this.state.account.logo && (
                                            <Button type="button" variant="link" onClick={this.accountLogoRemoveButton}>
                                                <FiTrash2/> Remove
                                            </Button>
                                        )}
                                    </Box>
                                    <Box width={1/3} className='form-label'>
                                        Primary Color
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <Flex>
                                            <Box>
                                                <Input
                                                    type="text"
                                                    name="branding.primary"
                                                    placeholder="#ffffff"
                                                    value={this.state.account.branding.primary}
                                                    onChange={this.onFormChange}
                                                    style={{ width: '90px' }}
                                                    mr={3}
                                                    className={
                                                        this.state.account.branding.primary &&
                                                        !this.isColor(this.state.account.branding.primary) &&
                                                        'error'
                                                    }
                                                />
                                                {this.state.account.branding.primary &&
                                                    !this.isColor(this.state.account.branding.primary) && (
                                                        <InputError>Invalid primary color</InputError>
                                                    )}
                                            </Box>
                                            <Box>
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        background: this.state.account.branding.primary
                                                    }}
                                                />
                                            </Box>
                                        </Flex>
                                    </Box>
                                    <Box width={1/3} className='form-label'>
                                        Secondary Color
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <Flex>
                                            <Box>
                                                <Input
                                                    type="text"
                                                    name="branding.secondary"
                                                    placeholder="#ffffff"
                                                    value={this.state.account.branding.secondary}
                                                    onChange={this.onFormChange}
                                                    style={{ width: '90px' }}
                                                    mr={3}
                                                    className={
                                                        this.state.account.branding.secondary &&
                                                        !this.isColor(this.state.account.branding.secondary) &&
                                                        'error'
                                                    }
                                                />
                                                {this.state.account.branding.secondary &&
                                                    !this.isColor(this.state.account.branding.secondary) && (
                                                        <InputError>Invalid secondary color</InputError>
                                                    )}
                                            </Box>
                                            <Box>
                                                <div
                                                    style={{
                                                        display: 'inline-block',
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        background: this.state.account.branding.secondary
                                                    }}
                                                />
                                            </Box>
                                        </Flex>
                                    </Box>

                                    {(this.state.account && this.state.account.custom_domain) &&
                                        <>
                                            <Box width={1/3} className='form-label'>
                                                Custom Domain
                                            </Box>
                                            <Box width={2/3} className='form-data'>
                                                <Input
                                                    type="text"
                                                    name="custom_domain"
                                                    placeholder="Custom Domain"
                                                    value={this.state.account.custom_domain}
                                                    disabled
                                                />
                                            </Box>

                                            <Box width={1/3} className='form-label'>
                                                Favicon
                                            </Box>
                                            <Box width={2/3} className='form-data'>
                                                {this.state.account.favicon ? (
                                                    <Box mb={2}>
                                                        <img
                                                            src={this.state.account.favicon}
                                                            style={{ width: '16px', borderRadius: '4px', overflow: 'hidden' }}
                                                            alt="Favicon"
                                                        />
                                                    </Box>
                                                ) : (
                                                    <></>
                                                )}

                                                <Button
                                                    type="button"
                                                    variant="link"
                                                    onClick={this.faviconUploadButton}
                                                    disabled={this.state.uploadingFavicon}
                                                    mr={3}
                                                >
                                                    {this.state.uploadingFavicon ? 'Uploading...' : <><FiCamera/> Upload image</>}
                                                </Button>
                                                <input type="file" id="organization_favicon" accept="image/x-icon, image/vnd.microsoft.icon" hidden />
                                                {this.state.account.favicon && (
                                                    <Button type="button" variant="link" onClick={this.faviconRemoveButton}>
                                                        <FiTrash2/> Remove
                                                    </Button>
                                                )}
                                            </Box>
                                        </>
                                    }

                                    <Box width={1/3} className='form-label'>
                                        Screener Background
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        {this.state.account.screener_bg ? (
                                            <Box mb={2}>
                                                <img
                                                    src={this.state.account.screener_bg}
                                                    style={{ width: '48px', borderRadius: '4px', overflow: 'hidden' }}
                                                    alt="Screener Background"
                                                />
                                            </Box>
                                        ) : (
                                            <></>
                                        )}

                                        <Button
                                            type="button"
                                            variant="link"
                                            onClick={this.screenerBgUploadButton}
                                            disabled={this.state.uploadingScreenBg}
                                            mr={3}
                                        >
                                            {this.state.uploadingScreenBg ? 'Uploading...' : <><FiCamera/> Upload image</>}
                                        </Button>
                                        <input type="file" id="organization_screener_bg" accept=".png, .jpg, .jpeg" hidden />
                                        {this.state.account.screener_bg && (
                                            <Button type="button" variant="link" onClick={this.screenerBgRemoveButton}>
                                                <FiTrash2/> Remove
                                            </Button>
                                        )}
                                    </Box>
                                    <Box width={1/3} className='form-label'>
                                        Email & Screener Footer
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <TextAreaAutosize
                                            name="email_footer"
                                            placeholder="Email Footer"
                                            value={this.state.account.email_footer}
                                            onChange={this.onFormChange}
                                            style={{ width: '100%', height: '200px' }}
                                            className='theme-input'
                                            mb={4}
                                        ></TextAreaAutosize>
                                    </Box>
                                </Box>

                                {/*<Box width={1/4} mt={4}>
                                    <H2>Panelist Fatigue</H2>
                                    <Label className='quiet thin'>
                                        If you want to prevent adding a panelist to a new study if they've
                                        participated recently, you can define that here.
                                    </Label>
                                </Box>
                                <Box width={3/4} mt={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                    
                                    <Box width={1/3} className='form-label'>
                                        Duration (days)
                                    </Box>
                                    <Box width={2/3} className='form-data'>

                                        <Input
                                            type="text"
                                            name="panelist_fatigue"
                                            placeholder="0 days"
                                            value={this.state.account.panelist_fatigue}
                                            onChange={this.onFormChange}
                                            style={{ width: '90px' }}
                                        />
                                    </Box>
                                    
                                </Box>*/}

                                <Box width={1/4} mt={4}>
                                    <H2>Email Domains</H2>
                                    <Label className='quiet thin'>
                                        When you send an email in Panelfox, the recipient sees that it comes from your Full
                                        Name, but the &quot;From&quot; e-mail is support@panelfox.io. If you would like this
                                        &quot;From&quot; e-mail to be your email, you need to add a domain.
                                    </Label>
                                </Box>
                                <Box width={3/4} mt={4} sx={{flexWrap: 'wrap', display: 'flex', fontSize: 1}}>

                                    <Box width={1/3} className='form-label'>
                                        Domains
                                    </Box>
                                    <Box width={2/3} className='form-data'>

                                        {this.state.account.domains && this.state.account.domains.length > 0 ?
                                            this.state.account.domains.map(d => {
                                                return <Flex sx={{justifyContent: 'space-between', position: 'relative'}} className='nice-element rounded fs-13 black' mb={3}>
                                                    <Button type='button' variant='link' className='link-small red'
                                                            sx={{position: 'absolute', top: '-11px', right: '-7px'}}
                                                            onClick={() => this.onDeleteDomain(d.id)}><FiXCircle className='circle' style={{fontSize: '16px', background: '#fff'}} /></Button>
                                                    <Box>{d.domain}</Box>
                                                    <Box sx={{position: 'relative'}}>
                                                        {this.isDomainVerified(d) ? 
                                                            <span className='green fs-12'><FiCheckCircle className='va-top fs-13' style={{marginTop: '4px'}} /> Verified</span>
                                                            :
                                                            <>
                                                                <span className='yellow fs-12'>Not verified</span>
                                                                {/*<Button variant='primary' onClick={() => this.setState({ showModalVerifyDomain: true, domain_selected: d })}>Verify</Button>*/}
                                                            </>
                                                        }
                                                    </Box>
                                                </Flex>
                                            })
                                            :
                                            <Box fontSize={1}>Please contact support@panelfox.io to set up a custom Email Domain.</Box>
                                        }

                                        {/*<Button
                                            type="button"
                                            variant="secondary-gray"
                                            onClick={() => this.setState({ showModalCreateDomain: true })}
                                        >
                                            + Add domain
                                        </Button>*/}
                                    </Box>
                                    
                                    <Box width={1/3} className='form-label'>
                                        Sender Profiles
                                    </Box>
                                
                                    <Box width={2/3} className='form-data'>
                                        {this.showSenderProfiles() ?
                                            <>
                                                {this.state.sender_profiles_loading == true && 
                                                    <div style={{ marginBottom: '44px' }}>
                                                        <LoadingWrapper>
                                                            <LoadingIndicator />
                                                        </LoadingWrapper>
                                                    </div>
                                                }

                                                {this.state.sender_profiles.map(sp => {
                                                    return <Flex sx={{justifyContent: 'space-between', position: 'relative'}} className='nice-element rounded fs-13 black' mb={3}>
                                                        <Button variant='link' className='link-small red'
                                                                sx={{position: 'absolute', top: '-11px', right: '-7px'}}
                                                                onClick={() => this.onDeleteSenderProfile(sp.id)}><FiXCircle className='circle' style={{fontSize: '16px', background: '#fff'}} /></Button>
                                                        <Box>{sp.name}<br/>{sp.email}</Box>
                                                        <Box sx={{position: 'relative'}}>
                                                            <Button variant='link' className='link-small va-top' mr={0} onClick={() => { this.setState({sender_profile_selected: sp, showModalSenderProfile: true }) }}><FiEdit /> Edit</Button>
                                                            
                                                        </Box>
                                                    </Flex>;
                                                })}

                                                <Button
                                                    type="button"
                                                    variant="secondary"
                                                    onClick={() => this.setState({ showModalSenderProfile: true })}
                                                >
                                                    + Add sender profile
                                                </Button>
                                            </>
                                            :
                                            <Box fontSize={1}>You must have a verified domain to add a Sender Profile.</Box>
                                        }
                                    </Box>
                                </Box>
                                <Box width={1/4} mt={4}>
                                    <H2>Panelist Scheduling</H2>
                                    <Label className='quiet thin'>
                                        You can restrict panelists from rescheduling and cancelling scheduled sessions.
                                    </Label>
                                </Box>
                                <Box width={3/4} mt={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                    
                                    <Box width={1/3} className='form-label'>
                                        Allow rescheduling & cancellations
                                    </Box>
                                    <Box width={2/3} className='form-data'>
                                        <Switch
                                            mt={2}
                                            className="switch-small"
                                            name='allow_session_changes'
                                            checked={this.state.account.allow_session_changes ? true : false}
                                            onClick={(e) => {
                                                this.onFormChange({
                                                    target: { name: 'allow_session_changes', value: e.target.value }
                                                });
                                            }}
                                            //onClick={() => this.toggleNotification(key)}
                                        />
                                    </Box>
                                </Box>
                                {/* <Label htmlFor="token" mt={3}>Token</Label>
                                <Box>{this.state.account.token}</Box> */}
                            </Flex>
                        </form>

                        <br />
                        <br />

                        <NiceModal
                            isOpen={this.state.showModalSenderProfile}
                            shouldCloseOnOverlayClick
                            onRequestClose={this.handleCloseModalSenderProfile}
                            title={`${this.state.sender_profile_selected.id ? 'Edit' : 'Add'} sender profile`}
                        >
                                <form onSubmit={this.onSubmitFormSenderProfile}>
                                    <Box fontSize={1} mb={3}>
                                        Add the Full Name and E-mail to create a new "From" email.<br/>
                                        <em>Example: John Smith &lt;john.smith@some-company.com&gt;</em>
                                    </Box>
                                    <Label>Full Name</Label>
                                    <Input type="text" name="sender_profile_name"
                                        value={this.state.sender_profile_selected.name}
                                        onChange={(e) => { const { sender_profile_selected } = this.state; sender_profile_selected.name = e.target.value; this.setState({sender_profile_selected}) }}
                                        autoFocus
                                        required
                                        />
                                    <Label mt={3}>E-mail</Label>
                                    <Input type="text" name="sender_profile_email"
                                        value={this.state.sender_profile_selected.email}
                                        onChange={(e) => { const { sender_profile_selected } = this.state; sender_profile_selected.email = e.target.value; this.setState({sender_profile_selected}) }}
                                        required
                                        disabled={this.state.sender_profile_selected.id ? true : false}/>
                                    <Box className='modal-actions'>
                                        <Button type="submit" variant="primary" className="modal-primary" mr={0} disabled={this.state.onCreateSenderProfile_loading}>
                                            {this.state.sender_profile_selected.id ? 'Update' : 'Add'} sender profile
                                        </Button>
                                    </Box>
                                </form>
                        </NiceModal>

                        <ReactModal
                            isOpen={this.state.showModalCreateDomain}
                            shouldCloseOnOverlayClick
                            onRequestClose={this.handleCloseModalCreateDomain}
                        >
                            <Box m={4}>
                                <form onSubmit={this.onCreateDomain}>
                                    <H1>Create a domain</H1>
                                    <Box fontSize={1} mb={3}>
                                        Enter the part of your email after the @ sign. For john@google.com, the domain would be <u>google.com</u>.
                                    </Box>
                                    <Label>Domain</Label>
                                    <Input type="text" name="create_domain_url" required autoFocus placeholder="yourdomain.com" />
                                    <Box style={{ textAlign: 'right' }} mt={4}>
                                        <Button
                                            variant="tertiary"
                                            type="button"
                                            onClick={this.handleCloseModalCreateDomain}
                                            mr={2}
                                        >
                                            Cancel
                                        </Button>
                                        <Button type="submit" mr={0} disabled={this.state.onCreateDomain_loading}>
                                            Create domain
                                        </Button>
                                    </Box>
                                </form>
                            </Box>
                        </ReactModal>

                        <ReactModal
                            isOpen={this.state.showModalVerifyDomain}
                            shouldCloseOnOverlayClick
                            onRequestClose={this.handleCloseModalVerifyDomain}
                            style={{ content: { width: '980px' } }}
                        >
                            <Box m={4} fontSize={1}>
                                {this.state.domain_selected.id && 
                                    <form onSubmit={this.onVerifyDomain}>
                                        <H1>Verify {this.state.domain_selected.domain}</H1>

                                        <Box style={{borderRadius: '4px', background: '#f7f7f7', padding: '16px'}}>
                                            <Box fontSize={1}>
                                                Create <strong>2 new DNS records</strong> in your website domain's hosting settings.
                                                Copy the <strong>Name</strong> and <strong>Value</strong>, and paste them in the respective fields in your website domain's DNS Settings.
                                            </Box>
                                        </Box>

                                        <Flex width={'100%'} sx={{gridGap: 3}} mt={3}>
                                            <Box width={1/2}>
                                                <Flex width={'100%'}>
                                                    <Box width={'64px'} mr={2}>
                                                        <Label>Type</Label>
                                                        <Box mt={2}>
                                                            TXT
                                                        </Box>
                                                    </Box>
                                                    <Box flexGrow={1}>
                                                        <Label>Name</Label>
                                                        <Input type="text" disabled value={this.dkimKeyStripDomain()} />
                                                    </Box>
                                                    <Box>
                                                        <Label>&nbsp;</Label>
                                                        <Button
                                                            variant="tertiary-icon"
                                                            type='button'
                                                            mr={0}
                                                            ml={2}
                                                            onClick={() => {
                                                                helpers.copyToClipboard(this.dkimKeyStripDomain());
                                                                const { toastManager } = this.props
                                                                toastManager.add('Copied', {
                                                                    appearance: 'success',
                                                                    autoDismiss: true
                                                                });
                                                            }}
                                                        >
                                                            <FiCopy />
                                                        </Button>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                            <Box width={1/2}>
                                                <Label>Value</Label>
                                                <Flex width={'100%'}>
                                                    <Box flexGrow={1}>
                                                        <Input type="text" disabled value={this.state.domain_selected.dkimvalue} />
                                                    </Box>
                                                    <Box>
                                                        <Button
                                                            variant="tertiary-icon"
                                                            mr={0}
                                                            ml={2}
                                                            type='button'
                                                            onClick={(e) => {
                                                                helpers.copyToClipboard(this.state.domain_selected.dkimvalue);
                                                                const { toastManager } = this.props
                                                                toastManager.add('Copied', {
                                                                    appearance: 'success',
                                                                    autoDismiss: true
                                                                });
                                                            }}
                                                        >
                                                            <FiCopy />
                                                        </Button>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                        </Flex>
                                        <Flex width={'100%'} sx={{gridGap: 3}} mt={3}>
                                            <Box width={1/2}>

                                                
                                                <Flex width={'100%'}>

                                                    <Box width={'64px'} mr={2}>
                                                        <Label>Type</Label>
                                                        <Box mt={2}>
                                                            CNAME
                                                        </Box>
                                                    </Box>
                                                    <Box flexGrow={1}>
                                                        <Label>Name</Label>
                                                        <Input type="text" disabled value={this.returnpathKeyStripDomain()} />
                                                    </Box>
                                                    <Box>
                                                        <Label>&nbsp;</Label>
                                                        <Button
                                                            variant="tertiary-icon"
                                                            type='button'
                                                            mr={0}
                                                            ml={2}
                                                            onClick={() => {
                                                                helpers.copyToClipboard(this.returnpathKeyStripDomain());
                                                                const { toastManager } = this.props
                                                                toastManager.add('Copied', {
                                                                    appearance: 'success',
                                                                    autoDismiss: true
                                                                });
                                                            }}
                                                        >
                                                            <FiCopy />
                                                        </Button>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                            <Box width={1/2}>
                                                <Label>Value</Label>
                                                <Flex width={'100%'}>
                                                    <Box flexGrow={1}>
                                                        <Input type="text" disabled value={this.state.domain_selected.returnpathvalue} />
                                                    </Box>
                                                    <Box>
                                                        <Button
                                                            variant="tertiary-icon"
                                                            mr={0}
                                                            ml={2}
                                                            type='button'
                                                            onClick={(e) => {
                                                                helpers.copyToClipboard(this.state.domain_selected.returnpathvalue);
                                                                const { toastManager } = this.props
                                                                toastManager.add('Copied', {
                                                                    appearance: 'success',
                                                                    autoDismiss: true
                                                                });
                                                            }}
                                                        >
                                                            <FiCopy />
                                                        </Button>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                        </Flex>
                                        <Box mt={4} sx={{color: '#666'}}>
                                            After you have added the above DNS entries, click <strong>Verify DNS entries</strong> below.
                                            Even if you added everything correctly it may take 1hr to 24hr for the verification to come back successful.
                                        </Box>

                                        <Box style={{ textAlign: 'right' }} mt={4}>
                                            <Button
                                                variant="tertiary"
                                                type="button"
                                                onClick={this.handleCloseModalVerifyDomain}
                                                mr={2}
                                            >
                                                Cancel
                                            </Button>
                                            <Button type="submit" mr={0} disabled={this.state.onVerifyDomain_loading}>
                                                Verify DNS entries
                                            </Button>
                                        </Box>
                                    </form>
                                }
                            </Box>
                        </ReactModal>
                    </AppPageWrapperSectionBody>
                </AppPageWrapper>
            </Flex>
        );
    }
}

export default withToastManager(SettingsPage);
